import { render } from "./AdvertisementModeration.vue?vue&type=template&id=67d63b5a"
import script from "./AdvertisementModeration.vue?vue&type=script&lang=js"
export * from "./AdvertisementModeration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__